import React, { useEffect } from 'react';
import './MindwarPrivacy.css';

function MindwarPrivacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-wrapper">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>GİZLİLİK POLİTİKASI</h1>
          <p className="last-updated">Son Güncelleme: 07.12.2023</p>
        </div>

        <div className="privacy-content">
          <div className="section">
            <h2>1. Giriş</h2>
            <p>
              Mindwar ("Uygulama") olarak gizliliğinize önem veriyoruz. Bu Gizlilik Politikası,
              Mindwar uygulamasını ve ilgili hizmetleri ("Hizmet") kullandığınızda kişisel
              verilerinizin nasıl toplandığını, kullanıldığını, paylaşıldığını ve korunduğunu
              açıklar.
            </p>
            <p>
              Hizmetimizi kullanarak, bu politikada belirtilen veri uygulamalarını kabul etmiş
              olursunuz.
            </p>
          </div>

          <div className="section">
            <h2>2. Veri Sorumlusu</h2>
            <p>Mindwar uygulamasıyla ilgili veri işleme faaliyetlerinden sorumlu kişi/kurum:</p>
            <div className="contact-box">
              <p><strong>Geliştirici:</strong> Hüseyin Selman Atabek</p>
              <p><strong>E-posta:</strong> selmanatabek@hotmail.com</p>
              <p><strong>Telefon:</strong> +90 555 334 23 32</p>
            </div>
          </div>

          <div className="section">
            <h2>3. Topladığımız Veriler</h2>
            <p>Uygulamanın özelliklerine bağlı olarak aşağıdaki türde verileri toplayabiliriz:</p>
            <ul>
              <li>
                <strong>Hesap Bilgileri:</strong> Ad, kullanıcı adı, e-posta adresi, profil
                bilgileri.
              </li>
              <li>
                <strong>Kullanım Verileri:</strong> Uygulama içi etkileşimler, istatistikler,
                tercih ettiğiniz ayarlar.
              </li>
              <li>
                <strong>Cihaz ve Teknik Bilgiler:</strong> Cihaz türü, işletim sistemi,
                tarayıcı türü, IP adresi (mümkün olduğunda anonimleştirilmiş), dil ve bölge
                ayarları.
              </li>
              <li>
                <strong>Çerezler ve Benzeri Teknolojiler (web sürümü için):</strong> Oturum,
                tercih ve analiz çerezleri.
              </li>
            </ul>
          </div>

          <div className="section">
            <h2>4. Verileri Kullanma Amaçlarımız</h2>
            <ul>
              <li>Uygulamayı sunmak, çalışmasını sağlamak ve geliştirmek,</li>
              <li>Kullanıcı deneyimini kişiselleştirmek,</li>
              <li>Hesap ve hizmetle ilgili sizinle iletişim kurmak,</li>
              <li>Uygulamanın kullanımını analiz ederek performansı ve özellikleri iyileştirmek,</li>
              <li>Yasal yükümlülüklerimizi yerine getirmek.</li>
            </ul>
          </div>

          <div className="section">
            <h2>5. Hukuki Dayanaklar</h2>
            <p>Kişisel verilerinizi aşağıdaki hukuki sebeplere dayanarak işleriz:</p>
            <ul>
              <li>Hizmetin sunulması için <strong>sözleşmenin ifası</strong>,</li>
              <li>
                Uygulamayı geliştirme ve güvenliği sağlama gibi
                <strong>meşru menfaatler</strong>,
              </li>
              <li>Bazı durumlarda <strong>açık rızanız</strong>,</li>
              <li>İlgili mevzuat gereği <strong>hukuki yükümlülükler</strong>.</li>
            </ul>
          </div>

          <div className="section">
            <h2>6. Verilerin Paylaşımı</h2>
            <p>Kişisel verileriniz, yalnızca aşağıdaki durumlarda üçüncü kişilerle paylaşılabilir:</p>
            <ul>
              <li>
                <strong>Hizmet sağlayıcılar:</strong> Barındırma (hosting), analiz, hata
                izleme, e-posta hizmetleri gibi teknik sağlayıcılar.
              </li>
              <li>
                <strong>Yasal zorunluluklar:</strong> Kanunen zorunlu olduğunda mahkemeler ve
                resmi makamlar.
              </li>
              <li>
                <strong>Birleşme/devralma durumları:</strong> Uygulamanın devri veya satışı
                halinde, gerekli gizlilik taahhütleriyle sınırlı olarak.
              </li>
            </ul>
            <p>
              Verilerinizi, açık rızanız olmadan üçüncü taraflara pazarlama amacıyla satmayız.
            </p>
          </div>

          <div className="section">
            <h2>7. Çerezler ve Takip Teknolojileri (Web İçin)</h2>
            <p>Mindwar'ın web sürümünde şu tür çerezler kullanılabilir:</p>
            <ul>
              <li>Zorunlu çerezler (oturumun devamı, güvenlik, kimlik doğrulama),</li>
              <li>Tercih çerezleri (dil, tema vb.),</li>
              <li>Analiz çerezleri (kullanımı anlamak ve uygulamayı geliştirmek için).</li>
            </ul>
            <p>
              Tarayıcı ayarlarından çerezleri yönetebilir veya silebilirsiniz; ancak bazı
              çerezleri engellemeniz durumunda uygulamanın bazı özellikleri düzgün
              çalışmayabilir.
            </p>
          </div>

          <div className="section">
            <h2>8. Veri Saklama Süreleri</h2>
            <p>Kişisel verileriniz,</p>
            <ul>
              <li>Hesabınız aktif olduğu sürece,</li>
              <li>İlgili yasal saklama ve zamanaşımı süreleri boyunca,</li>
              <li>
                Meşru menfaatlerimiz kapsamında gerekli olan makul süre boyunca saklanır.
              </li>
            </ul>
            <p>
              Artık gerekli olmayan veriler silinir, anonimleştirilir veya güvenli şekilde
              imha edilir.
            </p>
          </div>

          <div className="section">
            <h2>9. Veri Güvenliği</h2>
            <p>
              Verilerinizi korumak için uygun teknik ve idari tedbirler alıyoruz; şifreleme,
              erişim kontrolü ve güvenlik güncellemeleri gibi önlemler kullanıyoruz. Ancak
              hiçbir sistemin tamamen güvenli olmadığını ve internet üzerinden yapılan
              veri iletimlerinin belli riskler taşıdığını belirtmek isteriz.
            </p>
          </div>

          <div className="section">
            <h2>10. Haklarınız</h2>
            <p>
              Bulunduğunuz ülkenin veri koruma mevzuatına (örneğin KVKK, GDPR vb.) bağlı
              olarak aşağıdaki haklara sahip olabilirsiniz:
            </p>
            <ul>
              <li>Hangi verilerinizin işlendiğine dair <strong>bilgi talep etme</strong>,</li>
              <li>Kişisel verilerinize <strong>erişim</strong>,</li>
              <li>Eksik veya hatalı verilerin <strong>düzeltilmesini</strong> talep etme,</li>
              <li>Belirli durumlarda verilerinizin <strong>silinmesini</strong> isteme,</li>
              <li>
                Verilerinizin işlenmesinin belirli durumlarda
                <strong>sınırlandırılmasını</strong> talep etme,
              </li>
              <li>
                Meşru menfaatlere dayalı veri işleme faaliyetlerine
                <strong>itiraz</strong> etme,
              </li>
              <li>
                Uygun olduğunda verilerinizin <strong>taşınabilirliğini</strong> talep etme.
              </li>
            </ul>
            <p>
              Bu haklardan birini kullanmak için aşağıdaki iletişim bilgilerinden bizimle
              irtibata geçebilirsiniz.
            </p>
          </div>

          <div className="section">
            <h2>11. Çocukların Gizliliği</h2>
            <p>
              Mindwar genel olarak 13 yaş altı çocuklara yönelik değildir. 13 yaşın altındaki
              bir çocuktan bilerek kişisel veri topladığımızı fark edersek, bu verileri silmek
              için gerekli adımları atarız.
            </p>
          </div>

          <div className="section">
            <h2>12. Üçüncü Taraf Bağlantıları</h2>
            <p>
              Uygulama, üçüncü taraf web sitelerine veya hizmetlerine bağlantılar içerebilir.
              Bu sitelerin içerik veya gizlilik uygulamalarından sorumlu değiliz. İlgili
              sitelerin kendi gizlilik politikalarını incelemenizi öneririz.
            </p>
          </div>

          <div className="section">
            <h2>13. Bu Gizlilik Politikasındaki Değişiklikler</h2>
            <p>
              Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Önemli değişiklikler
              yaptığımızda, uygulama içinde veya web sitemizde bildirim yayınlarız ve "Son
              güncelleme" tarihini güncelleriz. Değişikliklerden sonra Mindwar'ı kullanmaya
              devam etmeniz, güncellenmiş politikayı kabul ettiğiniz anlamına gelir.
            </p>
          </div>

          <div className="section">
            <h2>14. İletişim</h2>
            <p>Bu gizlilik politikasıyla ilgili her türlü soru, talep veya şikayet için:</p>
            <div className="contact-box">
              <p><strong>E-posta:</strong> selmanatabek@hotmail.com</p>
              <p><strong>Telefon:</strong> +90 555 334 23 32</p>
              <p><strong>Web sitesi:</strong> https://www.atabekhsa.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MindwarPrivacy;
